module.exports = __webpack_public_path__ + "static/media/moneyTransfer.4d411385.svg";